import poweredByImg from '../../assets/Resources/Images/newPwdBy.png';


const AllPageFooter = ({ pageNumber, propLogo }) => {
  return (
    <div
      className="footer"
      // style={{height:'40mm', margin:'0mm 10mm', position: 'absolute'}}
    >
      <div style={{position: 'absolute', left: '0', right: '0', bottom: '0mm', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <div>
          {/* @if (!string.IsNullOrWhiteSpace(propShieldLogo)) */}
          {
            <img
              src={propLogo ? `data:image/png;base64,${propLogo}` : ""}
              style={{height:'60px', width:'auto'}}
            />
          }
        </div>

        <div style={{textAlign: 'center', color: '#000', fontSize: '15px', fontFamily: 'Arial, sans-serif', width: '120px'}}>
          Page No. {pageNumber}
        </div>

        <div>
          <img src={poweredByImg} style={{height:'60px', width:'auto'}} />
        </div>
      </div>
    </div>
  );
};
export default AllPageFooter;
